import React from 'react';
import './GlowingBackground.css';

/**
 * AtmosphericBackground
 * Replaces canvas particle system with Udghosh's CSS-based:
 *   1. Ink-black base
 *   2. Animated radial gold spotlight
 *   3. Film grain overlay (rendered by index.css .grain-overlay)
 */
const GlowingBackground = () => {
  return (
    <>
      {/* Solid ink-black base */}
      <div className="atm-base" />

      {/* Radial gold spotlight — animated via CSS */}
      <div className="atm-spotlight" aria-hidden="true" />

      {/* Secondary ambient glow — lower-left */}
      <div className="atm-glow-secondary" aria-hidden="true" />

      {/* Film grain — fixed overlay across entire page */}
      <div className="grain-overlay" aria-hidden="true" />
    </>
  );
};

export default GlowingBackground;
